<template>
    <div class="heating-statistics-warp">
        <monitorTitle nub="7" text="加热统计" width="auto" />

        <div class="box">
            <div id="heating-statistics" style="width: 550px;height:230px;"></div>
        </div>
    </div>
</template>

<script>
    const echarts = require('echarts');
    import {
        UserStore
    } from '@/utils/Mixin'
    export default {
        mixins: [UserStore],
        data() {
            return {
                list: []
            }
        },
        watch: {
            Data(n) {
                this.getData()
            },
            list() {
                this.init()
            }
        },
        methods: {
            getData() {
                let list = []
                if (this.Data && this.Data.data7 && this.Data.data7.items1) {
                    list = this.Data.data7.items1
                }
                this.list = list
                // this.list = [{
                //         "x": "广州",
                //         "y": "25"
                //     },
                //     {
                //         "x": "惠州",
                //         "y": "39"
                //     },
                //     {
                //         "x": "汕头",
                //         "y": "22"
                //     },
                //     {
                //         "x": "汕尾",
                //         "y": "54"
                //     },
                //     {
                //         "x": "厦门",
                //         "y": "38"
                //     },
                //     {
                //         "x": "深圳",
                //         "y": "59"
                //     },
                //     {
                //         "x": "东莞",
                //         "y": "43"
                //     },
                //     {
                //         "x": "揭阳",
                //         "y": "32"
                //     },
                //     {
                //         "x": "中山",
                //         "y": "40"
                //     },
                //     {
                //         "x": "肇庆1",
                //         "y": "44"
                //     },
                //     {
                //         "x": "肇庆2",
                //         "y": "4"
                //     },
                //     {
                //         "x": "肇庆3",
                //         "y": "12"
                //     },
                //     {
                //         "x": "肇庆4",
                //         "y": "12"
                //     },
                //     {
                //         "x": "肇庆5",
                //         "y": "4"
                //     },
                //     {
                //         "x": "肇庆6",
                //         "y": "24"
                //     }
                // ]
            },
            init() {
                // 基于准备好的dom，初始化echarts实例
                var myChart = echarts.init(document.getElementById('heating-statistics'));

                let xAxisData = []
                let seriesData = []

                this.list.forEach((i, k) => {
                    xAxisData.push(i.x || '')
                    seriesData.push(i.y || 0)
                })

                // 指定图表的配置项和数据
                let option = {
                    title: {
                        subtext: '单位：天',
                        subtextStyle: {
                            //文字颜色
                            color: '#74a0bf',
                            //字体大小
                            fontSize: 12
                        }
                    },
                    grid: {
                        x: "6%", //x 偏移量
                        width: "92%", // 宽度
                        height: "56%" // 高度
                    },
                    dataZoom: [ //给x轴设置滚动条
                        {
                            start: 0, //默认为0
                            end: 100 - 1500 / 31, //默认为100
                            type: 'slider',
                            // 显示滚动条
                            show: false,
                            xAxisIndex: [0],
                            handleSize: 0, //滑动条的 左右2个滑动条的大小
                            height: 4, //组件高度
                            left: '10%', //左边的距离
                            right: '10%', //右边的距离
                            bottom: 18, //右边的距离
                            borderColor: "#000",
                            fillerColor: '#01b3e4',
                            borderRadius: 5,
                            backgroundColor: '#33384b', //两边未选中的滑动条区域的颜色
                            showDataShadow: false, //是否显示数据阴影 默认auto
                            showDetail: false, //即拖拽时候是否显示详细数值信息 默认true
                            realtime: true, //是否实时更新
                            filterMode: 'filter',
                        },
                        // 下面这个属性是里面拖到
                        {
                            type: 'inside',
                            show: true,
                            xAxisIndex: [0],
                            start: 0, //默认为1
                            end: 100 - 1500 / 31, //默认为100
                        },
                    ],
                    tooltip: {
                        show: true,
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#01b3e4'
                            }
                        }
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: true,
                        data: xAxisData,
                        // 刻度
                        axisTick: {
                            show: false
                        },
                        axisLine: {
                            lineStyle: {
                                type: 'solid',
                                color: '#74a0bf', //左边线的颜色
                                width: '1' //坐标线的宽度
                            }
                        },
                        axisLabel: {
                            textStyle: {
                                // 坐标值得具体的颜色
                                color: '#74a0bf',
                                fontSize: 12
                            }
                        }
                    },
                    yAxis: {
                        type: 'value',
                        // 是否是脱离 0 值比例，true：自适应
                        scale: false,
                        minInterval: 20, //分割刻度
                        splitNumber: 5,
                        max: function(value) { //取最大值向上取整为最大刻度
                            return Math.ceil(value.max + 20)
                        },
                        axisLine: {
                            lineStyle: {
                                type: 'solid',
                                color: '#74a0bf',
                                width: '1'
                            }
                        },
                        axisLabel: {
                            textStyle: {
                                color: '#74a0bf',
                                fontSize: 12
                            }
                        },
                        splitLine: {
                            show: true, //X网格线
                            lineStyle: { //x网格线
                                color: '#002d37'
                            }
                        }
                    },
                    series: [{
                        data: seriesData,
                        type: 'line',
                        areaStyle: {
                            opacity: 0.8,
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgba(175, 57, 79,1)'
                            }, {
                                offset: 1,
                                color: 'rgba(68, 36, 52,0.5)'
                            }])
                        },
                        lineStyle: {
                            color: '#f94762',
                            width: 3
                        },
                        // 圆弧
                        smooth: true,
                        // 拐点
                        symbol: 'circle',
                        symbolSize: 9,
                        itemStyle: {
                            borderWidth: 1,
                            borderColor: '#ff475d',
                            color: '#ffffff'
                        },
                        // 文本标签
                        label: {
                            show: true,
                            position: 'top',
                            align: 'left',
                            fontSize: 12,
                            color: '#ffffff'
                        },
                    }],
                    showAllSymbol: 0
                };
                // 使用刚指定的配置项和数据显示图表。
                myChart.setOption(option);
            }
        }
    }
</script>

<style lang="less" scoped>
    .heating-statistics-warp {
        margin-bottom: 32px;
        width: 597px;

        .box {
            display: flex;
            align-items: center;
            justify-content: space-between;
            box-sizing: border-box;
            height: 238px;
            background-image: url("/static/images/home/chart-bg-2.png");
            background-size: 100% 100%;
            background-repeat: no-repeat;
            background-position: center;

            #heating-statistics {
                margin: 0 auto;
            }
        }
    }
</style>
